import { openProfileModalWithData } from "../../../CommonPresenters"

export default () => {
  openProfileModalWithData()
}
